import React from 'react';
import './WeatherStyle.css';

const WeatherForm = props => (
  <div className="card-body bg-transparent mx-auto">
      <form onSubmit={props.getWeather} className="row mx-auto">        
        <div className="col-sm-4 mb-2 mx-auto">
            <input type="text" name="city" placeholder="Your City Name" className="form-control" autoFocus/>
        </div> 
        <button className="btn btn-success btn-md col-sm-4 mb-2" > Get Weather </button>            
      </form> 
  </div>  
);

export default WeatherForm;